export default __webpack_public_path__ + "static/media/mark.b63bc50e.svg";